import { useEffect, useState } from "react";

const CHAT = [["Alex", "Je te passe devant ce soir."], ["Julie", "Revanche ?"], ["Sam", "5 bons pronos d'affilée !"], ["Inès", "Les croissants lundi, c'est pour toi."],
  ["Karim", "Match vedette : je prends les Celtics."], ["Léa", "+3 pts, merci les Lakers."], ["Tom", "Qui a osé parier sur Detroit ?"], ["Nora", "Je remonte 2e du classement !"],
  ["Hugo", "Défi accepté."], ["Maya", "Le dernier organise le resto."], ["Yanis", "Plus que 10 min pour pronostiquer."], ["Chloé", "Rival de la semaine : toi."],
  ["Enzo", "Série de 7, qui dit mieux ?"], ["Sarah", "Je savais que Denver passerait."]];
const SLOTS = [
  { pos: "left-0 top-6", tail: "rounded-bl-none", tone: "bg-[#B7F52A] text-[#101310]", drift: "mpl-drift-a", every: 4200 },
  { pos: "right-0 bottom-16", tail: "rounded-br-none", tone: "border border-white/15 bg-[#131B30] text-white", drift: "mpl-drift-b", every: 5300 },
  { pos: "-left-4 bottom-40", tail: "rounded-tl-none", tone: "bg-white text-[#101310]", drift: "mpl-drift-c", every: 6100 },
];
const randomOther = (taken) => {
  const free = CHAT.map((_, i) => i).filter((i) => !taken.includes(i));
  return free[Math.floor(Math.random() * free.length)];
};

export function HeroBubbles() {
  const [shown, setShown] = useState(() => [0, 1, 2].map((n) => (n * 5) % CHAT.length));
  useEffect(() => {
    const timers = SLOTS.map((s, n) => setInterval(() => {
      setShown((cur) => cur.map((v, k) => (k === n ? randomOther(cur) : v)));
    }, s.every + Math.random() * 1200));
    return () => { timers.forEach(clearInterval); };
  }, []);
  return SLOTS.map((slot, n) => {
    const [who, text] = CHAT[shown[n]];
    return (
      <span key={n} className={`absolute ${slot.pos} ${slot.drift} hidden sm:block`} data-testid={`landing-bubble-${n + 1}`}>
        <span key={shown[n]} className={`mpl-pop block max-w-[280px] rounded-2xl ${slot.tail} ${slot.tone} px-3 py-2 text-xs font-bold shadow-xl`}>
          <span className="opacity-60">{who} :</span> «&nbsp;{text}&nbsp;»
        </span>
      </span>
    );
  });
}
